import { render, staticRenderFns } from "./ProfileVerifications.vue?vue&type=template&id=7d1cf708&scoped=true&"
import script from "./ProfileVerifications.vue?vue&type=script&lang=js&"
export * from "./ProfileVerifications.vue?vue&type=script&lang=js&"
import style0 from "./ProfileVerifications.vue?vue&type=style&index=0&id=7d1cf708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1cf708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d1cf708')) {
      api.createRecord('7d1cf708', component.options)
    } else {
      api.reload('7d1cf708', component.options)
    }
    module.hot.accept("./ProfileVerifications.vue?vue&type=template&id=7d1cf708&scoped=true&", function () {
      api.rerender('7d1cf708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Other/ProfileVerifications.vue"
export default component.exports